// Stub misc API service - using Record<string, any> to allow any method access
const miscService: Record<string, any> = {
  getAll: async () => ({ data: [] }),
  getById: async (id: string) => ({ data: null }),
  create: async (data: any) => ({ data }),
  update: async (id: string, data: any) => ({ data }),
  delete: async (id: string) => ({ data: null }),
  getNotifications: async () => ({ data: [] }),
  getDownloads: async () => ({ data: [] }),
  excelExportRequest: async (params: any) => ({ data: null }),
  exportRequest: async (params: any) => ({ data: null }),
};

export default miscService;
